import React, {Component} from 'react';
import './App.css';
import './style/base.scss';

import {
  Switch,
  Redirect,
  Route,
  HashRouter,
} from 'react-router-dom';

import {connect} from 'react-redux';
import {refresh_admin} from './redux/models/admin';

import Detail from './pages/Detail/detail';
import Subject from './pages/Subject/subject';
import NewSubject from './pages/NewSubject/newSubject'
import Fault from './pages/Fault/fault';
import Share from './pages/Share/share';
import Topic from './pages/Topic/';
// import NotFound from './pages/NotFound/';

import 'antd-mobile/dist/antd-mobile.css';

@connect(
  state => ({admin: state.admin}),
  {refresh_admin}
)

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentWillMount() {
    const script = document.createElement('script')
    script.src = 'https://s22.cnzz.com/z_stat.php?id=1275168103&web_id=1275168103'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  shouldComponentUpdate() {

  }

  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" component={Fault}></Route>
          <Route path="/detail/:type/:uuid/:videoType?" component={Detail}></Route>
          <Route path="/subject/:type/:uuid" component={Subject}></Route>
          {/* 专题 */}
          <Route path="/newSubject/:uuid" component={NewSubject}></Route> 
          {/* 分享 */}
          <Route path="/share" component={Share}></Route>
          <Route path="/topic" component={Topic}></Route>
          <Redirect path="*" to='/'></Redirect>
        </Switch>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js